import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './OrderHistory.css';

const OrderHistory = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState('all'); // 'all', 'processing', 'delivered'

  useEffect(() => {
    const orderHistory = JSON.parse(localStorage.getItem('orderHistory') || '[]');
    // Sort by date (newest first)
    const sortedOrders = orderHistory.sort((a, b) => 
      new Date(b.orderDate) - new Date(a.orderDate)
    );
    setOrders(sortedOrders);
  }, []);

  const filteredOrders = orders.filter(order => {
    if (filter === 'all') return true;
    return order.status.toLowerCase() === filter;
  });

  const EmptyOrders = () => (
    <div className="empty-orders">
      <div className="empty-icon">📦</div>
      <h2>No Orders Yet</h2>
      <p>Start shopping to see your order history here!</p>
      <button className="start-shopping-btn" onClick={() => navigate('/')}>
        🛒 Start Shopping
      </button>
    </div>
  );

  if (orders.length === 0) {
    return (
      <div className="order-history-container">
        <EmptyOrders />
      </div>
    );
  }

  return (
    <div className="order-history-container">
      <div className="order-history-wrapper">
        <div className="history-header">
          <h1>📋 Order History</h1>
          <p className="total-orders">{orders.length} Total Orders</p>
        </div>

        <div className="filter-tabs">
          <button 
            className={`filter-tab ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All Orders
          </button>
          <button 
            className={`filter-tab ${filter === 'processing' ? 'active' : ''}`}
            onClick={() => setFilter('processing')}
          >
            Processing
          </button>
          <button 
            className={`filter-tab ${filter === 'delivered' ? 'active' : ''}`}
            onClick={() => setFilter('delivered')}
          >
            Delivered
          </button>
        </div>

        <div className="orders-list">
          {filteredOrders.length === 0 ? (
            <div className="no-results">
              <p>No {filter} orders found</p>
            </div>
          ) : (
            filteredOrders.map((order, index) => (
              <div key={index} className="order-card">
                <div className="order-card-header">
                  <div className="order-card-left">
                    <h3>Order #{order.orderId}</h3>
                    <span className="order-date">
                      {new Date(order.orderDate).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })}
                    </span>
                  </div>
                  <div className="order-card-right">
                    <span className={`order-status ${order.status.toLowerCase()}`}>
                      {order.status}
                    </span>
                  </div>
                </div>

                <div className="order-card-body">
                  <div className="order-items-preview">
                    {order.items.slice(0, 3).map((item, idx) => (
                      <div key={idx} className="order-item-preview">
                        <span className="item-name">{item.name}</span>
                        <span className="item-qty">×{item.quantity}</span>
                      </div>
                    ))}
                    {order.items.length > 3 && (
                      <span className="more-items">
                        +{order.items.length - 3} more item(s)
                      </span>
                    )}
                  </div>

                  <div className="order-details-grid">
                    <div className="order-detail">
                      <span className="detail-label">Items</span>
                      <span className="detail-value">{order.totalItems}</span>
                    </div>
                    <div className="order-detail">
                      <span className="detail-label">Payment</span>
                      <span className="detail-value">{order.paymentMethod}</span>
                    </div>
                    <div className="order-detail">
                      <span className="detail-label">Total</span>
                      <span className="detail-value total">${order.totalAmount}</span>
                    </div>
                  </div>

                  <div className="shipping-preview">
                    <strong>📦 Shipped to:</strong>
                    <p>{order.shippingDetails.address}, {order.shippingDetails.city}</p>
                  </div>
                </div>

                <div className="order-card-footer">
                  <button className="track-order-btn">
                    📍 Track Order
                  </button>
                  <button className="reorder-btn">
                    🔄 Reorder
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderHistory;
